import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import {useState} from 'react'
import {StyledCheckbox, StyledListItemText, StyledMenuItem} from './TableComponent/Styles'
import {useDispatch} from 'react-redux'
import {ClickAwayListener} from '@mui/material'
import headers from '../../configs/allProspectsTableHeader.json'
import {getColumnLabel} from '../../helper/getColumnLabelsHelper'
import {setCampaignAction} from '../../store/selectedView/campaignView/campaignActionSlice'
import PropTypes from 'prop-types'

const AddColumn = ({columns, currentHeaders, shouldSavePreferences, handleMenuItemClick}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const dispatch = useDispatch()

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClick = (option) => {
    const selectedIndex = currentHeaders.indexOf(option)
    const updatedHeaders =
      selectedIndex === -1
        ? [...currentHeaders, option] // If the option is not in the currentHeaders, add it
        : currentHeaders.filter((header) => header !== option) // If the option is in the currentHeaders, remove it
    handleMenuItemClick(updatedHeaders)
    if (shouldSavePreferences) {
      dispatch(setCampaignAction({actionName: 'saveUserColumnPreference', name: ''}))
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <ListItemButton
          sx={{paddingRight: 0}}
          aria-label="add-column"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClickListItem}
        >
          <ListItemText
            primaryTypographyProps={{
              fontSize: '12px',
              color: (theme) => theme.palette.common.black,
              fontWeight: (theme) => theme.typography.heading.fontWeight.bold
            }}
            primary="Add column +"
          />
        </ListItemButton>
        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
        >
          {columns?.map((option) => (
            <StyledMenuItem
              dense
              key={option}
              onClick={() => handleMenuClick(option)}
              disabled={headers.mandatoryColumn.includes(option)}
            >
              <StyledCheckbox checked={currentHeaders.includes(option)} />
              <StyledListItemText primary={getColumnLabel(headers.explicitKeyLabelMapping, option)} />
            </StyledMenuItem>
          ))}
        </Menu>
      </div>
    </ClickAwayListener>
  )
}

AddColumn.propTypes = {
  columns: PropTypes.array,
  currentHeaders: PropTypes.array,
  shouldSavePreferences: PropTypes.bool,
  handleMenuItemClick: PropTypes.func
}
export default AddColumn
